var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20767:226149",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20767:226149)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#EAECEF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 34.3591C52.9744 34.3591 55.3846 36.7694 55.3846 39.7437C55.3846 42.7181 52.9744 45.1283 50 45.1283C47.0256 45.1283 44.6154 42.7181 44.6154 39.7437C44.6154 36.7694 47.0256 34.3591 50 34.3591M50 57.436C57.6154 57.436 65.641 61.1796 65.641 62.8206V65.6411H34.359V62.8206C34.359 61.1796 42.3846 57.436 50 57.436M50 29.4873C44.3333 29.4873 39.7436 34.077 39.7436 39.7437C39.7436 45.4104 44.3333 50.0001 50 50.0001C55.6667 50.0001 60.2564 45.4104 60.2564 39.7437C60.2564 34.077 55.6667 29.4873 50 29.4873ZM50 52.5642C43.1538 52.5642 29.4872 56.0001 29.4872 62.8206V67.9488C29.4872 69.3591 30.641 70.5129 32.0513 70.5129H67.9487C69.359 70.5129 70.5128 69.3591 70.5128 67.9488V62.8206C70.5128 56.0001 56.8462 52.5642 50 52.5642Z",
    fill: "#BFC5CE"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAvatar);
export default __webpack_public_path__ + "static/media/no-avatar.6c2aeed6ba7463731f282b7979fb9619.svg";
export { ForwardRef as ReactComponent };